import { CustomerType } from "@origin-digital/platform-enums";
import { CommonParameters, IMcAppType, NavFlow, Tab } from "../mcApp.types";

export const billHistory: IMcAppType = {
  name: "billHistory_SAP",
  path: "/my-account/billing-payment/bill-history",
  description: "History of the users bills (pdfs) of a given caid",
  parameters: {
    properties: { caid: CommonParameters.caid },
  },
  navFlow: NavFlow.TAB,
  parent: Tab.BILLS,
  title: "Bill history",
  conditions: {
    intent: "billHistory",
    customerType: CustomerType.sap,
  },
};
